import { render, staticRenderFns } from "./RuleModal.vue?vue&type=template&id=0fc751ee&scoped=true&"
import script from "./RuleModal.vue?vue&type=script&lang=js&"
export * from "./RuleModal.vue?vue&type=script&lang=js&"
import style0 from "./RuleModal.vue?vue&type=style&index=0&id=0fc751ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc751ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc751ee')) {
      api.createRecord('0fc751ee', component.options)
    } else {
      api.reload('0fc751ee', component.options)
    }
    module.hot.accept("./RuleModal.vue?vue&type=template&id=0fc751ee&scoped=true&", function () {
      api.rerender('0fc751ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/RuleModal.vue"
export default component.exports